export const MEMBERSHIP_PACKAGES = [
  {
    id: 'BASIC_1T',
    name: 'Cơ bản (1 Tháng)',
    cost: 99000,
    tier: 'basic',
    features: [
      'Lưu trữ hồ sơ khám bệnh',
      'Lịch uống thuốc & nhắc nhở',
      'Cửa hàng TamCare',
      'Gọi khẩn cấp',
    ],
  },
  {
    id: 'PREMIUM_1T',
    name: 'Nâng cao (1 Tháng)',
    cost: 199000,
    tier: 'premium',
    popular: true,
    features: [
      'Tất cả tính năng Cơ bản',
      'Điểm danh sinh tồn hàng ngày',
      'AI đánh giá rủi ro',
      'AI tư vấn dinh dưỡng',
      'Toàn bộ tính năng AI',
    ],
  },
  {
    id: 'BASIC_6T',
    name: 'Cơ bản (6 Tháng)',
    cost: 499000,
    tier: 'basic',
    features: [
      'Tiết kiệm ~16% so với mua lẻ',
      'Lưu trữ hồ sơ khám bệnh',
      'Lịch uống thuốc & nhắc nhở',
      'Cửa hàng TamCare & gọi khẩn cấp',
    ],
  },
  {
    id: 'PREMIUM_6T',
    name: 'Nâng cao (6 Tháng)',
    cost: 999000,
    tier: 'premium',
    features: [
      'VIP Combo đầy đủ',
      'Điểm danh sinh tồn 24/7',
      'Toàn bộ tính năng AI',
      'Đặc quyền hỗ trợ 24/7',
    ],
  },
];

export function formatVnd(value) {
  return `${new Intl.NumberFormat('vi-VN').format(Number(value || 0))} đ`;
}

/** @deprecated use formatVnd */
export function formatPoints(value) {
  return formatVnd(value);
}

const TIER_LABEL_MAP = {
  Basic: 'Cơ bản',
  Premium: 'Nâng cao',
  BASIC: 'Cơ bản',
  PREMIUM: 'Nâng cao',
  basic: 'Cơ bản',
  premium: 'Nâng cao',
  Thường: 'Thường',
  'Chưa có gói': 'Chưa có gói',
};

export function normalizeTierLabel(label) {
  if (!label) return 'Thường';
  return TIER_LABEL_MAP[label] || label;
}

export function packageTierLabel(tier) {
  return tier === 'premium' ? 'Nâng cao' : 'Cơ bản';
}

export function mergePackagesFromApi(apiPackages) {
  if (!Array.isArray(apiPackages) || apiPackages.length === 0) {
    return MEMBERSHIP_PACKAGES;
  }
  return MEMBERSHIP_PACKAGES.map((local) => {
    const remote = apiPackages.find((p) => p.id === local.id);
    if (!remote) return local;
    return {
      ...local,
      cost: Number(remote.cost ?? local.cost),
      popular: remote.popular ?? local.popular,
    };
  });
}

export function memberLevelLabel(level) {
  if (level >= 2) return 'Nâng cao';
  if (level >= 1) return 'Cơ bản';
  return 'Chưa có gói';
}

export function previewOrderAmount(elderlyMembership, packageId) {
  const pkg = MEMBERSHIP_PACKAGES.find((p) => p.id === packageId);
  if (!pkg) return 0;

  const active = elderlyMembership?.hasMembership
    && elderlyMembership?.expiresAt
    && new Date(elderlyMembership.expiresAt) > new Date();
  const currentLevel = active ? Number(elderlyMembership.memberLevel || 0) : 0;

  if (!active) return pkg.cost;
  if (currentLevel >= (pkg.tier === 'premium' ? 2 : 1) && pkg.tier !== 'premium') {
    return pkg.cost;
  }
  if (pkg.tier === 'premium' && currentLevel === 1) {
    const basicSame = MEMBERSHIP_PACKAGES.find(
      (p) => p.tier === 'basic' && ((pkg.id.includes('6T') && p.id.includes('6T')) || (pkg.id.includes('1T') && p.id.includes('1T')))
    );
    if (basicSame) return pkg.cost - basicSame.cost;
  }
  return pkg.cost;
}
